import React, { useState } from 'react'
import { Button, Datepick, Flex, Flexed, MainWrap } from '../../utilities/Shared'
import { useNavigate } from 'react-router-dom'

const Reports = () => {


  const [begin, setBegin] = useState(new Date())
  const [end, setEnd] = useState(null)


const nav = useNavigate()

  return (
    <MainWrap>

        <Flexed fontSize="calc(1.2rem + .2vw)" margin="20px 0px 0px 0px" alignItems="center">
    <Flex flex="1" >Customer Follow Ups</Flex>
    <Flex>Begiining Date <br /><Datepick selected={begin} onChange={(date) => setBegin(date)}/></Flex>
    <Flex>Ending Date <br /><Datepick selected={end} onChange={(date) => setEnd(date)}/></Flex>
    <Flex ><Button style={{marginTop:"9px"}}>Run Report</Button></Flex>
        </Flexed>
    </MainWrap>
  )
}

export default Reports